import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import {gql} from "@irati/utils/gql"

const query = gql`
  mutation CreateStoreOrder($input: CreateStoreOrderInput!) {
    createStoreOrder(input: $input) {
      createStoreOrder {
        revenue
        storeName
        supplier
        ssoLink
        postUrl
        order {
          id
        }
        products {
          id
          name
          quantity
          price
          brand
          category
          variant
          sku
          department
        }
        errors {
          fieldName
          message
        }
      }
    }
  }
`

export const getCreateStoreOrderMutationKey = getQueryNames(query)[0]
export default query
